import { useGame } from "../lib/store.ts";

/**
 * Announcements and errors. Info toasts sit under the handshake and paused overlays; errors
 * (e.g. a refused card) stay on top.
 */
export function Toasts() {
  const toasts = useGame((s) => s.toasts);
  const info = toasts.filter((t) => t.tone === "info");
  const errors = toasts.filter((t) => t.tone === "error");
  return (
    <>
      <div className="toasts" aria-live="polite">
        {info.map((t) => (
          <div key={t.id} className="toast" role="status">
            {t.text}
          </div>
        ))}
      </div>
      <div className="toasts over" aria-live="assertive">
        {errors.map((t) => (
          <div key={t.id} className="toast error" role="alert">
            {t.text}
          </div>
        ))}
      </div>
    </>
  );
}
